import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("parallax", {
    mounted(element, binding) {
      element._originalTransform = window.getComputedStyle(element).transform;
      if (element._originalTransform === "none")
        element._originalTransform = void 0;
      console.log(element._originalTransform);
      const sanitizedOptions = { speed: binding.value.speed || 1 };
      const debouncedHandleScroll = debounce(() => handleScroll(element, sanitizedOptions), 10);
      element._handleScroll = () => debouncedHandleScroll();
      window.addEventListener("scroll", element._handleScroll);
    },
    unmounted(el) {
      window.removeEventListener("scroll", el._handleScroll);
      delete el._handleScroll;
    }
  });
});
function handleScroll(element, options) {
  if (!element || !isElementInViewport(element))
    return;
  const scrollY = -window.scrollY * options.speed;
  const scrollX = 0;
  requestAnimationFrame(() => {
    element.style.transform = `${element._originalTransform ? `${element._originalTransform} ` : ""}translate3d(${scrollX}px, ${scrollY}px, 0)`;
  });
}
function isElementInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
}
function debounce(callback, delay) {
  let inDebounce = null;
  return function(...args) {
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => callback.apply(this, args), delay);
  };
}
